import { useAppSelector } from '@/store/hooks';
//check if logged in user is customer
export const useCheckUserIsCustomer = () => {
  const customer = useAppSelector(
    (state) => state.user.authUserData.data.customer,
  );
  return {
    isUserCustomer: !!customer?.c_id,
    customerInfo: customer,
  };
};
